import React from 'react'

import { HeroHomeTwo } from '../index'

const HeroHomeBlockTwo = ({ preface, title, description, background, featureCards, gradient }) => {
  return (
    <HeroHomeTwo
      preface={preface}
      title={title}
      description={description}
      background={background}
      featureCards={featureCards}
      gradient={gradient}
    ></HeroHomeTwo>
  )
}

export default HeroHomeBlockTwo
